import { message, Typography } from 'antd';
import { ReactNode } from 'react';

/**
 *
 * @returns this component using for toast
 * @toast to showing message success toast
 * @errrorMessage to shpwing error message toast
 * @toastContainer to give a wrapper of toast success
 * @errorToast to give a wrapper of toast error
 */

const Toast = () => {
  const [toastApi, toastContainer] = message.useMessage({
    getContainer: (): HTMLElement => document.getElementById('toast') as HTMLElement,
  })
  const toast = async (
    message: string,
    type: 'success' | 'warning' | 'danger',
    icon?: ReactNode,
    action?: () => void,
    actionLabel?: string,
  ) => {
    toastApi.open({
      icon: <></>,
      className: `toast toast--${type}`,
      duration: 3,
      content: (
        <div className="flex items-center justify-center" data-testid="toast">
          {icon && <div className="flex items-center justify-center mr-3">{icon}</div>}
          <Typography.Text
            className={`text-sm ${type === 'warning' ? 'text-gray-800' : 'text-white'}`}
          >
            {message}
          </Typography.Text>
          <span
            data-testid="btn_toast_action"
            onClick={action}
            className={`ml-auto font-medium ${
              type === 'warning' ? 'text-gray-800' : 'text-warning-600'
            } cursor-pointer`}
          >
            {actionLabel}
          </span>
        </div>
      ),
    })
  }

  return { toastContainer, toast }
}

export default Toast
